import { get } from 'lodash';

const root = state => get(state, 'ReportsState.onHandReports');

export const getOnHandItems = state => get(root(state), 'onHandItems', []);
export const getLoadingOnHandItems = state =>
  get(root(state), 'loadingOnHandItems', false);
export const getLoadingOnHandItemsError = state =>
  get(root(state), 'loadingOnHandItemsError', null);
export const getAllSitesData = state => get(root(state), 'allSitesData', []);
export const getLoadingAllSites = state =>
  get(root(state), 'loadingAllSites', false);
export const getAllSitesLoadingError = state =>
  get(root(state), 'allSitesLoadingError', null);
export const getOnHandFifoItems = state =>
  get(root(state), 'onHandFifoItems', []);
export const getLoadingOnHandFifoItems = state =>
  get(root(state), 'loadingOnHandFifoItems', false);
export const getLoadingOnHandFifoItemsError = state =>
  get(root(state), 'loadingOnHandFifoItemsError', null);
export const getSelectedFifoSitesItems = state =>
  get(root(state), 'selectedFifoSitesItems', []);
export const getOnHandTransactionDetailsItems = state =>
  get(root(state), 'onHandTransactionDetailsItems', []);
export const getLoadingOnHandTransactionDetailsItems = state =>
  get(root(state), 'loadingOnHandTransactionDetailsItems', false);
export const getLoadingOnHandTransactionDetailsItemsError = state =>
  get(root(state), 'loadingOnHandTransactionDetailsItemsError', null);
export const getFromDateMax = state => get(root(state), 'fromDateMax', null);
export const getToDateMin = state => get(root(state), 'toDateMin', null);
export const getFromDateMaxTranDetail = state =>
  get(root(state), 'fromDateMaxTranDetail', null);
export const getToDateMinTranDetail = state =>
  get(root(state), 'toDateMinTranDetail', null);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/state/selectors.js